<script>
import axios from 'axios';

export default {
    name: 'WizardNavigation',
    props: {
        steps: Array,
        activeStep: Number
    }
};
</script>

<template>
    <div class="wizard-navigation">
        <div class="wizard-navigation-step" v-for="step in steps" :key="step.key" :class="[{ 'next': activeStep + 1 === step.key }, 'grid-column-' + step.key]">
            <div class="circle">
                <div class="circle-inner">
                    <span>{{step.key}}</span>
                </div>
            </div>
            <div class="title">
                 {{step.name}}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
@import '../../assets/scss/inputs.scss';
@import '../../assets/scss/grid.scss';

$circle-height: 50px;
$circle-width: 50px;

.wizard-navigation {
    display: grid;
    display: -ms-grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    -ms-grid-columns: 1fr 1fr 1fr;
    margin-bottom: 30px;

    &-step {
        position: relative;
        -ms-grid-row: 1;
        .circle {
            margin: 0 auto;
            width: $circle-width;
            height: $circle-height;
            border: 2px solid $orange;
            opacity: 1;
            border-radius: 50%;
            &-inner {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 5% auto;
                height: 90%;
                width: 90%;
                border: 1px solid #fff;
                background-color: $orange;
                border-radius: 50%;
                color: #fff;
                font-size: 18px;
            }
        }

        .title {
            font-size: 18px;
            color: $orange;
            font-weight: bold;
            margin-top: 12px;
            text-align: center;
        }

        &:before {
            content: '';
            position: absolute;
            top: $circle-height / 2;
            left: calc(-50% + #{$circle-width / 2});
            width: calc(100% - #{$circle-width});
            height: 2px;
            opacity: 1;
            background: $orange;
        }

        &:first-child::before {
            display: none;
        }
    }

    .wizard-navigation-step.next,
    .wizard-navigation-step.next ~ .wizard-navigation-step {
        .circle {
            border: 2px solid $grey-middle;
            opacity: 0.5;
            &-inner {
                background-color: transparent;
                color: $grey-middle;
            }
        }

        .title {
            color: $grey-middle;
            font-weight: normal;
        }

        &:before {
            opacity: 0.5;
            background: $grey-middle;
        }
    }
}
</style>
